import React, { useEffect, useState } from "react";
import api from "../api";
import "./Opportunities.css";

const CATEGORY_OPTIONS = [
  { value: "", label: "All Categories" },
  { value: "job", label: "Job" },
  { value: "house", label: "House" },
  { value: "scholarship", label: "School/Scholarship" },
];

export default function Opportunities() {
  const [opportunities, setOpportunities] = useState([]);
  const [filteredOpportunities, setFilteredOpportunities] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");

  const fetchOpportunities = async () => {
    try {
      const res = await api.get("members/opportunities/"); // returns all opportunities
      setOpportunities(res.data);
      setFilteredOpportunities(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchOpportunities();
  }, []);

  const handleCategoryChange = (e) => {
    const category = e.target.value;
    setSelectedCategory(category);

    if (category === "") {
      setFilteredOpportunities(opportunities);
    } else {
      setFilteredOpportunities(
        opportunities.filter((op) => op.category === category)
      );
    }
  };

  return (
    <div className="opportunities-container">
      <h1>Opportunities</h1>

      {/* Category Filter */}
      <div className="filter-section">
        <label htmlFor="category-filter">Filter by Category:</label>
        <select
          id="category-filter"
          value={selectedCategory}
          onChange={handleCategoryChange}
        >
          {CATEGORY_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>

      {filteredOpportunities.length === 0 ? (
        <p>No opportunities available.</p>
      ) : (
        <div className="opportunities-grid">
          {filteredOpportunities.map((op) => (
            <div key={op.id} className="opportunity-card">
              <h3 className="opportunity-title">{op.title}</h3>
              <p className="opportunity-category"><b>Category:</b> {op.category}</p>
              <p className="opportunity-description">{op.description}</p>
              {op.location && (
                <p className="opportunity-location"><b>Location:</b> {op.location}</p>
              )}
              <p className="opportunity-member">
                <b>Posted by:</b> {op.member.first_name} {op.member.last_name}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
